import { render, staticRenderFns } from "./BonusTimeSlices.vue?vue&type=template&id=b265fcd2&scoped=true"
import script from "./BonusTimeSlices.vue?vue&type=script&lang=js"
export * from "./BonusTimeSlices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b265fcd2",
  null
  
)

export default component.exports